import { createSelector } from '@reduxjs/toolkit';
import { getWidgetDisplayMode as getWidgetDisplayModeOperator } from 'conversations-internal-schema/widget-data/operators/widgetDataGetters';
import { getLatestWidgetData } from '../../widget-data/selectors/getLatestWidgetData';
export const getWidgetDisplayMode = createSelector(getLatestWidgetData, getWidgetDisplayModeOperator);